import React, { useCallback, useEffect, useRef, useState } from 'react';
import { SliderComponent, SliderChangeEventArgs } from '@syncfusion/ej2-react-inputs';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { debounce } from 'throttle-debounce';

export type DimensionSliderProps = {
    min: number
    max: number
    currentValue: number
    onSliderValueChanged: (value: number) => void
}

export const DimensionSlider = (props: DimensionSliderProps) => {

    const { t } = useTranslation();

    const { min, max, currentValue, onSliderValueChanged = () => { } } = props

    const [sliderValue, setSliderValue] = useState(min);
    const sliderValueListener = useRef(onSliderValueChanged);

    sliderValueListener.current = onSliderValueChanged;

    useEffect(()=>{
        setSliderValue(currentValue)
    },[currentValue])

    const debounceFunc = useCallback(debounce(100, (value: number) => {
        sliderValueListener.current(value);
    }), []);

    const isSame = max === min

    return <div className="sliderDiv" style={{display:'flex', flexDirection:'column'}}>
        {isSame && <span style={{color: 'red', fontSize: '10px'}}>min and max values are the same</span>}
        <div style={{width: '100%',opacity: isSame? 0.5: 1, display:'flex', flexDirection:'row' }}>
        {t("editor.custom.toolPanel_size_min")}

            <div className="slider">
                <SliderComponent id='default' min={min} max={max} value={sliderValue || min} changed={(args:SliderChangeEventArgs) => {
                    if (!Array.isArray(args.value)) {
                        setSliderValue(args.value);
                        debounceFunc(args.value)
                    }
                }}/>
            </div>

        {/* <div className="slider">
            <Slider min={min} max={max} value={sliderValue} onChange={(value) => {
                if (!Array.isArray(value)) {
                    setSliderValue(value);
                    debounceFunc(value)
                }
            }}
            />
        </div> */}
        {t("editor.custom.toolPanel_size_max")}
        </div>
    </div>
}